import * as Actions from '../actions'

const initialState = {
    data: {}
}

const screenshotsReducer = function (state=initialState, action) {
    switch(action.type){
        case Actions.GET_KUBE_SCREENSHOTS:
        {   
            return {
                ...state,
                data: action.payload
            }
        }
        default:
        {
            return state
        }
    }
}

export default screenshotsReducer;